import Swiper from 'swiper';
import {
	Pagination,
	Controller,
	EffectFade,
	Navigation,
	A11y,
} from 'swiper/modules';
import enterView from 'enter-view';

Alpine.data('timeline', (totalYears, miniMode = false) => {
	let timelineHeader;
	let timelineImages;

	return {
		loading: false,
		nextYear: '',
		activeYearIndex: totalYears - 1,

		init() {
			this.entryAnimations();

			if (!miniMode) {
				this.initialiseCarousel();

				timelineHeader.slideTo(totalYears - 1, 100);
			}
		},
		entryAnimations() {
			const entryDelayedElements =
				this.$root.querySelectorAll('.entry-delayed');

			entryDelayedElements.length &&
				enterView({
					selector: entryDelayedElements,
					once: true,
					offset: 0.4,
					enter(el) {
						el.classList.add('entry-delayed--active');

						setTimeout(() => {
							el.classList.add('entry-delayed--complete');
							el.nextElementSibling &&
								el.nextElementSibling.classList.add('entry-delayed--ready');
						}, 1200);
					},
				});
		},
		initialiseCarousel() {
			timelineImages = new Swiper('.our-impact-timeline__images', {
				modules: [EffectFade, A11y],
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				draggable: false,
				allowTouchMove: false,
				grabCursor: false,
				enabled: false,
				initialSlide: totalYears - 1,
				a11y: {
					enabled: true,
				},
			});

			timelineHeader = new Swiper('.our-impact-timeline__main-container', {
				modules: [Pagination, Controller, Navigation, A11y],
				slidesPerView: 'auto',
				spaceBetween: 30,
				centeredSlides: true,
				autoHeight: false,
				grabCursor: true,
				a11y: {
					enabled: true,
					prevSlideMessage: 'Previous item in the gallery',
					nextSlideMessage: 'Next item in the gallery',
				},
				// If we need pagination
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				controller: {
					control: timelineImages,
				},
				navigation: {
					nextEl: '.swiper-button--next',
					prevEl: '.swiper-button--prev',
				},
				on: {
					slideChangeTransitionStart: () => {
						this.activeYearIndex = timelineHeader.activeIndex;
						timelineImages.slideTo(timelineHeader.activeIndex, 300);
					},
					slideChangeTransitionEnd: () => {
						this.entryAnimations();
					},
				},
			});
		},
		goToSlide(index) {
			timelineHeader.slideTo(index, 300);
		},
		getOffsetTop(el) {
			const rect = el.getBoundingClientRect();
			const scrollTop =
				window.pageYOffset || document.documentElement.scrollTop;

			return rect.top + scrollTop;
		},
		goToSlideFromList(index) {
			this.loading = true;
			setTimeout(() => {
				this.goToSlide(index);

				// pause all videos
				this.$root.querySelectorAll('iframe[src]').forEach((iframe) => {
					iframe.src = iframe.dataset.src || iframe.src;
				});

				setTimeout(() => {
					// eslint-disable-next-line
					document.documentElement.scrollTop = document.body.scrollTop =
						this.getOffsetTop(document.querySelector('#page-wrap'));
					this.loading = false;
				}, 200);
			}, 1500);
		},
		isActiveSlide(index) {
			return this.activeYearIndex === index;
		},
	};
});
